import {Button} from 'antd';
import {DownloadOutlined} from '@ant-design/icons';
import {useAppDispatch} from '../../common/hooks';
import {liveBatteriesCSV} from './liveBatteriesSlice';
import {MAIN_FILTER} from './liveBatteries.type';

const DownloadCsvButton = ({filters}: {filters: MAIN_FILTER}) => {
  const dispatch = useAppDispatch();

  const downloadCsv = () => {
    dispatch(liveBatteriesCSV(filters))
      .unwrap()
      .then((x) => {
        const date = new Date(Date.now());
        const hiddenElement = document.createElement('a');
        const href = 'data:text/csv;charset:utf-8,' + x.data;
        hiddenElement.href = href;
        hiddenElement.target = '_self';
        hiddenElement.download =
          'battery_' + date.toLocaleDateString() + 'T' + date.toLocaleTimeString() + '.csv';
        hiddenElement.click();
      });
  };

  return (
    <Button onClick={downloadCsv} icon={<DownloadOutlined />}>
      Download CSV
    </Button>
  );
};

export default DownloadCsvButton;
